/*
 *
 * App actions
 *
 */

import {
  SET_AUTH_TOKEN,
  SET_USER,
  NOOP,
  SIGN_OUT,
} from './constants';

export const setAuthToken = (payload) => ({
  type: SET_AUTH_TOKEN,
  payload,
});

export const setUser = (data) => ({
  type: SET_USER,
  payload: {
    ...data
  },
});

export const noop = () => ({
  type: NOOP,
});

export const signOut = () => ({
  type: SIGN_OUT,
});



// WEBPACK FOOTER //
// ./src/containers/App/actions.js